<!-- DEPARTMENT PAGE -->
<template>
  <div class="wrapper">
  <div>
    <CButton color="info" @click="openModal"><b>Add New Department</b></CButton>
      <CRow class="mt-3">
      <div>       
      </div>
        <CCol sm="12">
          <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body">
                        <Datatable 
                            :items="items" 
                            :fields="fields" 
                            :meta="meta" 
                            @per_page="handlePerPage" 
                            @pagination="handlePagination" 
                            @search="handleSearch" 
                            @sort="handleSort"
                            @is_active="handleIsActive"
                            :btn_show="true"
                            :btn_edit="true"
                            :btn_deactivate="false"
                            :btn_reactivate="false"
                            :btn_destroy="true"
                            @show="handleShow"
                            @edit="handleEdit"
                            @deactivate="handleDeactivate"
                            @reactivate="handleReactivate"
                            @destroy="handleDestroy"
                        />
                    </div>
                </div>
            </div>
        </div>
      </CCol>
    </CRow> 
     <departmentmodal></departmentmodal>
    <alertmodal></alertmodal>
  </div>

  </div>
</template>

<script>
import Datatable from '@/components/datatables.vue' 
import axios from 'axios';

import department from '@/services/department';
import departmentmodal from './department_modal';

import alertmodal from '@/views/alert/modal.vue';
import EventBus from '@/eventBus';
import store from '@/store.js'

const token = localStorage.getItem('token');

export default {
  name: 'DepartmentTable',
  components: { Datatable, departmentmodal, alertmodal },
  data(){
    return {
      form:{
        name:'',
        description:'',
        
      },
      updateSubmit: false,
      fields: [
          {key: 'name', sortable: false, },
          {key: 'description', sortable: false},
          {key: 'head', sortable: false},
          {key: 'action', label: 'Action', sortable: false},
      ],
      items: [],
      meta: [],
      current_page: 1,
      per_page: 10,
      search: '',
      sortBy: 'name',
      sortByDesc: false,
    }
   },
    created() {
      //this.loadData()
  },
   mounted (){
     this.loadData()

      EventBus.$on('TABLE_UPDATE', (data) => {
      if(data){
          this.loadData();
      }
    });
   },
  methods: {
    openModal: function () {
       let Permission = store.state.user.authenticated.permission
      if (typeof Permission != 'undefined') {
        if(Permission.indexOf('Create/edit department (including assign HOD/assign member to core teams/etc)') !== -1){
          //IF ALLOW
      var params = {title: 'Add New Department', mode:'create'}
      EventBus.$emit('OPEN_MODAL_DEPARTMENT', params)
      //END ALLOW
        }else{
          //IF NOT
          var params = {title: 'Error', mode:'danger', data:'unautenticated'}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        } 
      }
      //SET END
    },
     openShow: function(id){
        let Permission = store.state.user.authenticated.permission
      if (typeof Permission != 'undefined') {
        if(Permission.indexOf('View department') !== -1){
          //IF ALLOW
      department.getDepartmentbyID(id)
      .then(res => {
      var params = {title: 'Detail department ', mode:'detail', data:res.data}
      EventBus.$emit('OPEN_DETAIL_DEPARTMENT', params)
      })   
      this.$router.push({name:'Department Detail',query: {Pud:id} }) 
      
      //open new tab
      //   let routeData = this.$router.resolve({path: '/department/department_detail',query: {Pud:id} }) 
      // window.open(routeData.href, '_blank');


      //END ALLOW
        }else{
          //IF NOT
          var params = {title: 'Error', mode:'danger', data:'unautenticated'}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        } 
      }
      //SET END  
        },

    openModalEdit(id){
       let Permission = store.state.user.authenticated.permission
      if (typeof Permission != 'undefined') {
        if(Permission.indexOf('Create/edit department (including assign HOD/assign member to core teams/etc)') !== -1){
          //IF ALLOW
        var params = {title: 'Edit Department', mode:'edit', data:id}
        EventBus.$emit('OPEN_MODAL_DEPARTMENT', params)
        //END ALLOW
        }else{
          //IF NOT
          var params = {title: 'Error', mode:'danger', data:'unautenticated'}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        } 
      }
      //SET END
    },

    destroy(id){
       //SET PERMISSION EACH FEATURE
      let Permission = store.state.user.authenticated.permission
      if (typeof Permission != 'undefined') {
        if(Permission.indexOf('Delete department') !== -1){
          //IF ALLOW
      if(confirm("Do you really want to delete?")){
        department.destroyDepartment(id)
        .then(res => {
          EventBus.$emit('TABLE_UPDATE', true)
          var params = {title: 'Success', mode:'success', data:res.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        }).catch ((err) => {
          var params = {title: 'Error', mode:'danger', data:err.response.data.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
       
      }  
       //END ALLOW
        }else{
          //IF NOT
          var params = {title: 'Error', mode:'danger', data:'unautenticated'}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        } 
      }
      //SET END
    },

     loadData() {
      let current_page = this.search == '' ? this.current_page:1
      var params = {
        headers: { "Authorization" : `Bearer ${token}` },
        page: this.current_page,
        per_page: this.per_page,
        search: this.search,
        sortby: this.sortBy,
        sortbydesc: this.sortByDesc ? 'DESC':'ASC',
        is_active: this.is_active,
      }
      department.getDepartmentDataSource(params)
      .then(res => {
          let getData = res.data
          this.items = getData.data
          //this.is_active = res.is_active
          this.meta = {
              total: getData.total,
              current_page: getData.current_page,
              per_page: getData.per_page,
              from: getData.from,
              to: getData.to,
              is_active: res.is_active
          }
      }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      })
      
    },
    handlePerPage(val) {
        this.per_page = val 
        this.loadData() 
    },
    
    handlePagination(val) {
        this.current_page = val 
        this.loadData()
    },
    
    handleSearch(val) {
        this.search = val 
        this.current_page = 1 
        this.loadData() 
    },
  
    handleSort(val) {
        this.sortBy = val.sortBy
        this.sortByDesc = val.sortDesc
        this.loadData()
    },
    
    handleIsActive(val) {
        this.is_active = val 
        this.loadData() 
    },

////HANDLE FUNCTION BUTTON ACTION////
    handleShow(val) {
        this.openShow(val) 
    }, 
    handleEdit(val) {
        this.openModalEdit(val) 
    },    
    handleDestroy(val) {
        this.destroy(val) 
    }, 
    

  }
}
</script>
